import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SortService, FilterService,EditSettingsModel,EditService , ReorderService, TreeGridComponent, ToolbarItems, Column } from '@syncfusion/ej2-angular-treegrid';
import { IEditCell, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { Query, DataManager } from '@syncfusion/ej2-data';
import { ApiService } from 'src/app/_services/api.service';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { v4 as uuidv4 } from 'uuid';



@Component({
  selector: 'app-survey-model-settings',
  templateUrl: './survey-model-settings.component.html',
  styleUrls: ['./survey-model-settings.component.css'],
  providers: [FilterService, SortService, ReorderService,EditService,MessageService]
})
export class SurveyModelSettingsComponent implements OnInit {
  public editSettings: EditSettingsModel;
  aggregationList:any[]=[];
  showDialog:boolean=false;
  questionParams?: IEditCell;
  title='';
  introtext='';
  id:number;
  cid:any;
  surveymodel={
    name:'',
    id_startup:0
  };
  selectedrecords:any[]=[];

 
  public questionList : object[] = [];
  
  @ViewChild(TreeGridComponent, { static: false }) treegrid: TreeGridComponent;

  
  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {
   
    this.editSettings ={ allowEditing: true, allowAdding: true, allowDeleting: true, mode:"Cell", newRowPosition: 'Child'}; 

    this.aggregationList=[];
    /*
      {
        id:1,
        aggregation:'aaaa',
        questions:[
            {
              id:2,
              aggregation:'bbb',
              question:'Normal'
            },
            {
              id:3,
              aggregation:'biuuiuibb',
              question:'Normal'
            }
        ]
      }
    ];
    */
    this.id=parseInt(this.route.snapshot.paramMap.get('id'));
    const params: any = {PageSize : 10000};
    this.apiService.get('surveys-models/listall',params).subscribe(data => {
      for (const g of data.Result) {
        if(g['id']==this.id){
          this.surveymodel=g;
        
          let settings=JSON.parse(g.jsonsettings);
          if(!settings){
            this.aggregationList=[];
          } else {
            this.aggregationList=settings.aggregationList;
            
            this.introtext=settings.introtext;
          }
          let sur=JSON.parse(g.json);
          let j=0;
          sur.pages.forEach((p)=>{
            p.elements.forEach((e)=>{
              j++;
             if(e.question_weight>0){
              let qname=e.name;
              if(e.title){
                if(typeof e.title === 'object' ){
                  if(e.title['default']){
                    qname=j+' '+e.title['default'];
                  } 
                  if(e.title['en']){
                    qname=j+' '+e.title['en'];
                  }
                  if(e.title['it']){
                    qname=j+' '+e.title['it'];
                  }
                  if(e.title['de']){
                    qname=j+' '+e.title['de'];
                  }
                  if(e.title['es']){
                    qname=j+' '+e.title['es'];
                  }
                } else {
                  qname=j+' '+e.title;
                }
               

              }

              this.questionList.push({text:qname,value:e.name});
             }
            });
          });
        }
      }

      this.questionParams = {
        params: {
            actionComplete: () => false,
            allowFiltering: true,
            dataSource: new DataManager(this.questionList),
            fields: { text: 'text', value: 'value' },
            query: new Query()
        }
      };
      this.treegrid.dataSource=this.aggregationList;
    });
  }

  public onChange(data,args: any): void {
    this.aggregationList.forEach((r,ind)=>{
      r.questions.forEach((q,ind2)=>{
        if(q.id==data.id){
           this.aggregationList[ind].questions[ind2].question=args.value;
  
        }
      });
    });
   }

  addRow1(data: any) {
  
    const guid = uuidv4();
    var childRow = {
      id:guid,
      question:'',
      questions:[]
    };
    this.cid=null;
    this.treegrid.editSettings.newRowPosition = 'Child';
    this.treegrid.addRecord(childRow, data.index);
  }

  rowSelected(args: RowSelectEventArgs) {
    this.selectedrecords= (this.treegrid as TreeGridComponent).getSelectedRecords();  // Get the selected records.
  }


  actionComplete(args): void {

  }

  addAggregation(){ 
   
    if(this.cid){
      this.aggregationList.forEach((r,ind)=>{
        if(r.id==this.cid){
          this.aggregationList[ind].aggregation=this.title;
        }
      });
   
    } else {
      const guid = uuidv4();
      var childRow = {
        id:guid,
        aggregation:this.title,
        questions:[]
      };
   //   this.treegrid.editSettings.newRowPosition = 'Top';
    //  this.treegrid.addRecord(childRow,0);
    this.aggregationList.push(childRow);
    this.treegrid.dataSource=[];
    setTimeout(()=>{
      this.treegrid.dataSource=this.aggregationList;

    },10);
    }
   
    this.treegrid.dataSource=[];
    setTimeout(()=>{
      this.treegrid.dataSource=this.aggregationList;
      this.showDialog=false;
    },10);

  }

  editAggregation(data){

    this.showDialog=true;
    this.cid=data.id;
    this.title=data.aggregation;

  }
  remove(data){
    this.aggregationList.forEach((r,ind)=>{
      if(data.id==r.id){
        this.aggregationList.splice(ind,1);
      }
    });
    this.treegrid.dataSource=[...this.aggregationList];
    setTimeout(()=>{
      this.treegrid.dataSource=this.aggregationList;
    },10);
  }

  save(){
    let params={
      id:this.id,
      jsonsettings:{
        aggregationList:this.aggregationList,
        introtext:this.introtext
      }
    };

    this.apiService.get('surveys-model/updatesettings',params).subscribe(data => {
      this.addSingle('success', 'Successo', 'Survey settings saved');
    });

    

  }
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

}